export default ({ store, route, redirect }) => {
  if (store.getters['auth/loggedIn']) {
    if (route.name === 'invitation') {
      return redirect('/', { convite: route.params.invitecode })
    } else {
      return redirect('/')
    }
  }
}
